import { cn } from '@/utils/cn';
import type { LabelProps } from './Label.types';
import styles from './Label.module.scss';

export function Label({
  children,
  required = false,
  disabled = false,
  className,
  ...props
}: LabelProps) {
  const labelClasses = cn(
    styles.label,
    disabled && styles['label--disabled'],
    className
  );

  return (
    <label className={labelClasses} {...props}>
      {children}
      {required && (
        <span className={styles.label__required} aria-label="required">
          *
        </span>
      )}
    </label>
  );
}

export default Label;
